import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './CatelogueItem.css';
import { faGift } from '@fortawesome/free-solid-svg-icons';
import Modal from './Modals/Modal';
import MarketingTool2Modal from './Modals/MarketingTool2Modal';

function MarketingTool2() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <div className="CIT NotYetAvailable" onClick={() => setIsOpen(true)}>
        <div className="CIT_A1">
          <FontAwesomeIcon icon={faGift} />
        </div>
        <div className="CIT_A2">
          Referrals
        </div>
      </div>
      <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
        <MarketingTool2Modal />
      </Modal>
    </div>
  );
}

export default MarketingTool2;
